import { EventDisplayDataRSVPOption } from "../../../../../../common/sesh_types";
import { InlineEmoji } from "../inline_emoji";

export function RSVPListImproved(props: {
	preset: EventDisplayDataRSVPOption[];
}) {
	const { preset } = props;
	const columns: JSX.Element[] = [];
	let index = 0;
	for (let option of preset) {
		const emoji = <InlineEmoji option={option} />;
		columns.push(
			<div
				key={index}
				className="column is-one-third-tablet is-one-third-mobile column-in-table-cell has-text-centered-tablet"
			>
				{emoji} <span>{option.rsvp_count}</span>
			</div>
		);
		index++;
	}
	return (
		<div className="flex gap-2">
			{preset.map((val, index) => (
				<div key={val.id} className="flex gap-1">
					<InlineEmoji option={val} />
					<span>{val.rsvp_count}</span>
				</div>
			))}
		</div>
	);
}
